export default __webpack_public_path__ + "static/media/avatarA5.05251d86.png";